import { render, staticRenderFns } from "./Profile.vue?vue&type=template&id=5e34b168&scoped=true&"
import script from "./Profile.vue?vue&type=script&lang=js&"
export * from "./Profile.vue?vue&type=script&lang=js&"
import style0 from "./Profile.scss?vue&type=style&index=0&id=5e34b168&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e34b168",
  null
  
)

export default component.exports